module.exports = __webpack_public_path__ + "static/media/signup-slider1.9d2c4ae2.png";